import { supabase } from "./supabaseClient";

// The email shown by the UI is never an authorization source. The current
// Supabase session and the server-side is_master_admin() check must both agree.
export const verifyCurrentAdminAccess = async expectedUserId => {
  const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
  if (sessionError) return false;
  const sessionUserId = sessionData?.session?.user?.id;
  if (!sessionUserId || !expectedUserId || sessionUserId !== expectedUserId) return false;
  const { data, error } = await supabase.rpc("is_master_admin");
  return !error && data === true;
};
